import { Component, Inject, Injector, OnInit } from "@angular/core";
import { TuiDialogContext, TuiDialogService } from "@taiga-ui/core";
import {
  PolymorpheusComponent,
  POLYMORPHEUS_CONTEXT,
} from "@tinkoff/ng-polymorpheus";
import { CodehelpService } from "virtue-form";
import { FeedbackformComponent } from "../feedbackform/feedbackform.component";
import { ApiService } from "src/app/core/services/shared/api.service";

@Component({
  selector: "app-collegeprofile",
  templateUrl: "./collegeprofile.component.html",
  styleUrls: ["./collegeprofile.component.scss"],
})
export class CollegeprofileComponent implements OnInit {
  universityData: any;
  src: String = "";
isGridDataUsed:boolean=false;
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    private codehelp: CodehelpService,
    public apiService: ApiService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("clg-profile");
    this.universityData = context.data;
    this.checkOutStateGridData(this.universityData);
  }

  checkOutStateGridData(item: any) {
    let outStateGridNotUsed = false;
    let preferOutStateGrid = false;
    this.isGridDataUsed=false;
    if (
      item.dropDownData?.result?.preferOutStateGrid !=undefined
    ) {
      preferOutStateGrid =item.dropDownData?.result?.preferOutStateGrid;
    }
    let meritName = item.dropDownData?.result?.institutionalGrants;
    Object.keys(meritName).forEach((key) => {
      if (meritName[key]?.outStateGridUsed != undefined) {
        // outStateGridNotUsed =meritName[key]?.outStateGridUsed == false &&preferOutStateGrid == true? true: false;
        outStateGridNotUsed =meritName[key]?.amount > 0 && meritName[key]?.outStateGridUsed == false && preferOutStateGrid == true? true: false;
        if(outStateGridNotUsed)
        {
          this.isGridDataUsed=outStateGridNotUsed;
          
        }
      }
    });
    // this.isGridDataUsed=outStateGridNotUsed;
  }

  ngOnInit(): void {
    // let src =
    //   "https://cdn.virtueanalytics.com/college-logos/" +
    //   this.universityData.dropDownData.ipedsId +
    //   ".png";
    // if (src) {
    //   this.src = src;
    // } else {
    //   this.src = "https://cdn.virtueanalytics.com/cache/college-icon-top5.png";
    // }
  }

  // getProfileImg()
  // {

  //   this.api

  // }

  SetContacFormate(val: string) {
    const regex = new RegExp(/[^0-9]/g);
    val = val.replace(regex, "");
    return this.codehelp.formatNumerWithType(val, "USA");
  }

  private openfeedBackForm = this.dialogService.open<any>(
    new PolymorpheusComponent(FeedbackformComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "",
      size: "m",
    }
  );

  openFeedBackForm() {
    this.openfeedBackForm = this.dialogService.open<any>(
      new PolymorpheusComponent(FeedbackformComponent, this.injector),
      {
        data: "",
        dismissible: false,
      }
    );
    this.openfeedBackForm.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  close() {
    this.context.completeWith("");
    // const dialog = document.querySelector("tui-dialog");
    // dialog.classList.remove("clg-profile");
  }
  setDefaultImage() {
    const defaultImageUrl =
      "https://cdn.virtueanalytics.com/cache/college-icon-top5.png";
    const imageElement = event.target as HTMLImageElement;
    imageElement.src = defaultImageUrl;
  }
  getFirstAndLastWords(str) {
    let result = "";
    const words = str.split("-");
    if (words.length >= 2) {
      const zeroindexvalue = words[0];
      const space = zeroindexvalue.split(" ");
      let lastElement = space[space.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
      return result;
    } else {
      const firstLetters = str.split(" ");
      let lastElement = firstLetters[firstLetters.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
    }
    return result;
  }
}
